import TomSelect from "tom-select/dist/js/tom-select.complete.min.js";

const clearFiltersBtn = document.getElementById('clear-filters-btn');
const tagFilter = document.getElementById('tag-filter');
// const tagList = JSON.parse(tagFilter.dataset.tagList);
// const options = tagList.map(tag => ({ value: tag.fields.name, text: tag.fields.name }));

document.querySelectorAll('.tags-select-field').forEach((el)=>{
	let settings = {
        plugins: ['remove_button'],
        persist: false,
        maxOptions: null,
        createOnBlur: true,
        onItemAdd:function() {
            this.setTextboxValue('');
            this.refreshOptions();
        },
        options: JSON.parse(tagFilter.dataset.tagList).map(tag => ({ value: tag.fields.name, text: tag.fields.name })),
    };
    const tomSelectInstance = new TomSelect(el,settings);

    clearFiltersBtn.addEventListener('click', () => {
        tomSelectInstance.clear();
    });
});
